import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { file_path } from './environment';

function Guides({ guides }) {
    const guideList = Object.entries(guides)
        .sort(([idA], [idB]) => parseInt(idA) - parseInt(idB))
        .map(([id, guide]) => {
            const latestYear = [...guide.years].sort((a, b) => b - a)[0];
            const href = `/research/${guide.guideType}/${latestYear}`;

            return (
                <div key={guide.id} className="research-guide-card">
                    <h4>{guide.guideType}</h4>
                    <Link to={href} className="research-guide-link">View {latestYear} schedule &rarr;</Link>
                </div>
            );
        });

    return <div className="research-guide-list">{guideList}</div>;
}

export default function ResearchIndex() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get(file_path('/research.json')).then((res) => {
            setGuides(res.data);
        });
    }, []);

    useEffect(() => {
        document.title = 'Research';
    }, []);

    return (
        <div className="container">
            <div className="body">
                <div className="portal-links-row">
                    <Link className="guides-return-link" to="/guides">Return to Portal</Link>
                    <a className="guides-return-link report-request-link" href="mailto:mbuckley@gmail.com?subject=Research%20Page%20Bug%20or%20Feature%20Request">Report a bug or request a feature</a>
                </div>
                <h2>Research Schedule</h2>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
